// extracted by mini-css-extract-plugin
module.exports = {"header-wrapper":"Patrons_header-wrapper__1DnFd","ubc":"Patrons_ubc__2MIpp","ntu":"Patrons_ntu__3hIJy"};